import Icon from "@ant-design/icons";
import type { GetProps } from "antd";

type CustomIconComponentProps = GetProps<typeof Icon>;

const ExitSvg = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 21.9009H5C3.89543 21.9009 3 21.0054 3 19.9009V15.9009H5V19.9009H19V5.90088H5V9.90088H3V5.90088C3 4.79631 3.89543 3.90088 5 3.90088H19C20.1046 3.90088 21 4.79631 21 5.90088V19.9009C21 21.0054 20.1046 21.9009 19 21.9009ZM11 16.9009V13.9009H3V11.9009H11V8.90088L16 12.9009L11 16.9009Z"
      fill="#BDA1C9"
    />
  </svg>
);

const NotesSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8333 0.5H2.16667C1.25 0.5 0.5 1.25 0.5 2.16667V13.8333C0.5 14.75 1.25 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V2.16667C15.5 1.25 14.75 0.5 13.8333 0.5ZM8.83333 12.1667H4.66667C4.20833 12.1667 3.83333 11.7917 3.83333 11.3333C3.83333 10.875 4.20833 10.5 4.66667 10.5H8.83333C9.29167 10.5 9.66667 10.875 9.66667 11.3333C9.66667 11.7917 9.29167 12.1667 8.83333 12.1667ZM11.3333 8.83333H4.66667C4.20833 8.83333 3.83333 8.45833 3.83333 8C3.83333 7.54167 4.20833 7.16667 4.66667 7.16667H11.3333C11.7917 7.16667 12.1667 7.54167 12.1667 8C12.1667 8.45833 11.7917 8.83333 11.3333 8.83333ZM11.3333 5.5H4.66667C4.20833 5.5 3.83333 5.125 3.83333 4.66667C3.83333 4.20833 4.20833 3.83333 4.66667 3.83333H11.3333C11.7917 3.83333 12.1667 4.20833 12.1667 4.66667C12.1667 5.125 11.7917 5.5 11.3333 5.5Z"
      fill="#6E6E6E"
    />
  </svg>
);

const NotesTakerSvg = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4918 9.13628L13.4918 15.9941L17.9944 15.9941L17.9944 9.13628C17.9944 4.08786 13.9642 -0.00585959 8.99414 -0.00585938L8.99414 4.56771C11.4792 4.56771 13.4967 6.61207 13.4967 9.14128L13.4918 9.13628Z"
      fill="white"
    />
    <path
      d="M9 16.0039L9 11.4318C6.51639 11.4318 4.5 9.38804 4.5 6.85962L4.5 0.00390605L0 0.00390586L-2.99673e-07 6.85962C-5.20277e-07 11.9065 4.02787 15.9989 8.99508 15.9989L9 16.0039Z"
      fill="#BDA1C9"
    />
  </svg>
);

export const ExitIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ExitSvg} {...props} />
);

export const NotesIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NotesSvg} {...props} />
);

export const NotesTakerIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NotesTakerSvg} {...props} />
);
